import classNames from "classnames";
import { Field, Form, withFormik } from "formik";
import { saveDraft } from "middleware/form";
import Button from "pages/_components/Button";
import { resizableRoute } from "pages/_components/Resizable";
import Container from "pages/_components/Container";
import Head from "pages/_components/Head";
import Heading from "pages/_components/Heading";
import I18n from "pages/_components/I18n";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import ButtonDrawer from "pages/_components/drawer/ButtonDrawer";
import TextField from "pages/_components/fields/TextField";
import Selector from "pages/_components/fields/formik/Selector";
import SelectorInput from "pages/_components/fields/formik/SelectorInput";
import Hint from "pages/_components/hints/Hint";
import CreateTemplateModal from "pages/forms/_components/CreateTemplateModal";
import TemplateList from "pages/forms/_components/TemplateList";
import Productselector from "pages/forms/_components/_fields/Productselector";
import { arrayOf, bool, func, shape, string } from "prop-types";
import React, { Component } from "react";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { goBack, push } from "react-router-redux";
import { actions as checkActions, selectors as checkSelector } from "reducers/checks";
import { actions as formActions } from "reducers/form";
import { selectors as sessionSelectors } from "reducers/session";
import { selectors as statusSelectors } from "reducers/status";
import { actions as templateActions, selectors as templateSelectors } from "reducers/template";
import { compose } from "redux";
import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import resolveDraftTransactionListGoBack from "util/draftTransactionListGoBack";
import { saveLocation } from "util/transaction";
import {
    applyEmbeddedV3ShellLayoutState,
    clearEmbeddedV3ShellLayoutState,
    isUxDashboardImprovementsEnabled,
    resolveEmbeddedV3GoBackPath,
} from "util/v3ShellLayoutSync";
import { getPostLoginHomePath } from "util/v3UxConfig";
import Yup from "yup";
import { CURRENCY_CODE } from "../../constants";

const FORM_ID = "new.check";

const CHECKS_INTERNAL = /^\/checks(\/|$)/;

function isEligibleChecksExit(pathname, currentPathname) {
    return (
        typeof pathname === "string" &&
        pathname.startsWith("/") &&
        !CHECKS_INTERNAL.test(pathname) &&
        pathname !== currentPathname
    );
}

class Checks extends Component {
    echeqUSDfuncionalites = configUtils.getBoolean("frontend.ECHEQsUSD.functionalities", false);

    static propTypes = {
        forEach: func.isRequired,
        fetching: bool.isRequired,
        dispatch: func.isRequired,
        documentType: string.isRequired,
        values: shape({}).isRequired,
        checksRequestData: shape({}).isRequired,
        location: shape({}).isRequired,
        checksAmount: shape({}).isRequired,
        checksTypesList: shape({}).isRequired,
        checksTypesListUSD: shape({}),
        setValues: func.isRequired,
        setErrors: func.isRequired,
        templates: {},
        loggedUser: shape({
            userId: string.isRequired,
        }).isRequired,
        accounts: arrayOf(
            shape({
                idProduct: string.isRequired,
            }),
        ).isRequired,
        isDesktop: bool.isRequired,
        isSmallDesktop: bool.isRequired,
        forceBack: bool,
        defaultAccount: string.isRequired,
        embeddedInV3Shell: bool,
        lastPathname: string,
    };

    static defaultProps = {
        templates: null,
        forceBack: false,
        checksTypesListUSD: [],
        embeddedInV3Shell: false,
        lastPathname: "",
    };

    state = {
        alreadyFetch: false,
        alreadyFetchRest: false,
        buttonDisabled: false,
    };

    componentWillMount = () => {
        const { dispatch, location } = this.props;
        saveLocation(this.props);

        if (location.pathname === "/checks") {
            dispatch(checkActions.clearRequestData());
        }
    };

    componentDidMount() {
        const { dispatch, loggedUser } = this.props;

        dispatch(checkActions.fetchAccounts(loggedUser.userId));
        dispatch(templateActions.loadTemplateList("requestCheckbook"));
        this.applyV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const { embeddedInV3Shell, isDesktop, checksRequestData, templates } = this.props;
        if (
            prevProps.embeddedInV3Shell !== embeddedInV3Shell ||
            prevProps.isDesktop !== isDesktop ||
            prevProps.checksRequestData?.returnToPending !== checksRequestData?.returnToPending ||
            prevProps.checksRequestData?.checksTransactionListGoBackPath !==
                checksRequestData?.checksTransactionListGoBackPath ||
            prevProps.templates !== templates
        ) {
            this.applyV3ShellLayout();
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    resolveChecksExitPath = () => {
        const { checksRequestData, embeddedInV3Shell, location, lastPathname } = this.props;
        const currentPathname = location?.pathname || "";
        if (checksRequestData?.returnToPending) {
            return checksRequestData.checksTransactionListGoBackPath || resolveDraftTransactionListGoBack("");
        }
        const returnFromState = location?.state?.return;
        if (typeof returnFromState === "string" && returnFromState.startsWith("/")) {
            return returnFromState;
        }
        if (isEligibleChecksExit(lastPathname, currentPathname)) {
            return lastPathname;
        }
        const home = getPostLoginHomePath(isUxDashboardImprovementsEnabled());
        if (embeddedInV3Shell) {
            return resolveEmbeddedV3GoBackPath(home, lastPathname);
        }
        return null;
    };

    applyV3ShellLayout = () => {
        const { embeddedInV3Shell, isDesktop, dispatch, checksRequestData, templates } = this.props;
        const titleKey = checksRequestData?.returnToPending ? "modify.check.request" : "new.check.request";
        const goBackPath = this.resolveChecksExitPath();
        applyEmbeddedV3ShellLayoutState(dispatch, {
            embeddedInV3Shell,
            isDesktop,
            scopes: ["requestChecks", "form"],
            titleKey,
            goBackPath,
            rightContentMobile: templates?.length > 0 ? this.rightContentMobile() : undefined,
        });
    };

    handleForceBack = () => {
        const { dispatch } = this.props;
        dispatch(goBack());
    };

    handleBack = () => {
        const { dispatch, checksRequestData } = this.props;
        const exitPath = this.resolveChecksExitPath();

        if (checksRequestData && checksRequestData.forceBack) {
            this.handleForceBack();
        } else if (exitPath) {
            dispatch(push(exitPath));
        } else {
            dispatch(goBack());
        }
    };

    centerContentMobile = () => (
        <div>
            <h1 className="m-0">{i18n.get("new.check.request")}</h1>
        </div>
    );

    createCheckBooksAmount = () => {
        const cantidadChequeras = configUtils.getInteger("client.checkbook.amount", 5);
        let options = [];

        for (let i = 1; i <= cantidadChequeras; i++) {
            options = [...options, { value: i, label: i }];
        }
        return options;
    };

    renderInputs = (values, setValues) => (
        <Col sm={12} className="col-no-pad-mobile" style={{ paddingLeft: 0, paddingRight: 0 }}>
            <h4 style={{ marginLeft: "1rem" }}>{i18n.get(`${FORM_ID}.authorized.data`)}</h4>
            <Col sm={12} md={4} lg={4} className="col-no-pad-mobile">
                <Field
                    component={SelectorInput}
                    name="document"
                    idForm={FORM_ID}
                    selectorSize="small"
                    selectProps={{
                        name: "documentType",
                        value: {
                            value: values.documentType,
                            label: values.documentType,
                        } /* values.documentType */,
                        options: [
                            { value: "DNI", label: "DNI" },
                            { value: "CUIT", label: "CUIT" },
                            { value: "CUIL", label: "CUIL" },
                            { value: "CDI", label: "CDI" },
                        ],
                    }}
                    label={i18n.get(`${FORM_ID}.documentType.label`)}
                    inputProps={{
                        name: "document",
                        value: values.document,
                        inputmode: "numeric",
                        type: "number",
                        className: "input-without-arrows pl-3 w-100 form-control",
                    }}
                    onChange={(type, stringDocument) => {
                        setValues({
                            ...values,
                            documentType: type?.value ? type.value : type,
                            document: stringDocument,
                        });
                    }}
                    inputMaxLength={values.documentType === "DNI" ? 8 : 11}
                />
            </Col>
            <Col sm={12} md={4} lg={4} className="col-no-pad-mobile">
                <Field name="name" idForm={FORM_ID} component={TextField} mode="edit" hidePlaceholder />
            </Col>
            <Col sm={12} md={4} lg={4} className="col-no-pad-mobile">
                <Field name="surname" idForm={FORM_ID} component={TextField} mode="edit" hidePlaceholder />
            </Col>
        </Col>
    );

    getCheckBookChecksAmount = (checkType, amount) => {
        const { dispatch, setValues, values } = this.props;
        setValues({ ...values, checkBookChecksAmount: amount || "" });
        if (!this.echeqUSDfuncionalites) {
            dispatch(checkActions.fetchChecksAmount(checkType));
        }
    };

    checksAmountOptions = (filteredCheckTypes) => {
        const { checksAmount, values } = this.props;

        let options = [];
        if (!this.echeqUSDfuncionalites) {
            checksAmount.forEach((amount) => {
                options = [...options, { value: amount, label: amount }];
            });
        } else {
            const { checksTypes } = values;

            const checkTypeSelected = filteredCheckTypes?.find((checkType) => checkType.value === checksTypes);
            options = checkTypeSelected?.checksAmount?.map((amount) => ({
                value: amount,
                label: amount,
            }));
        }

        return options;
    };

    saveDraft = () => {
        const { dispatch, values, checksRequestData, checksTypesList, accounts, checksTypesListUSD } = this.props;
        const { checksTypes } = values;

        let filteredCheckTypes = checksTypesList;
        if (this.echeqUSDfuncionalites) {
            const completeAccount = accounts.find(({ idProduct }) => idProduct === values.account);
            filteredCheckTypes = completeAccount?.currency === CURRENCY_CODE.USD ? checksTypesListUSD : checksTypesList;
        }
        const completeCheckType = filteredCheckTypes?.find(({ value }) => value === checksTypes);

        this.setState({ buttonDisabled: true });

        dispatch(
            formActions.saveDraft({
                idForm: "requestCheckbook",
                idActivityDraft: "account.checks",
                data: {
                    ...values,
                    checksTypes: completeCheckType,
                    account: values.account ? { value: values.account } : null,
                },
                idTransaction: checksRequestData?.returnToPending ? checksRequestData.idTransaction : null,
            }),
        );
    };

    handleCreateTemplateClick = () => {
        const { dispatch } = this.props;
        dispatch(templateActions.createTemplate());
    };

    handleTemplateSelect = (template) => {
        const { setValues, setErrors, accounts, checksTypesListUSD, checksTypesList } = this.props;
        let checkType = template.checksTypes;
        if (this.echeqUSDfuncionalites) {
            // Se valida que el id de tipp chequera exista en el listado actual
            const completeAccount = accounts.find(({ idProduct }) => idProduct === template?.account);
            const filteredCheckTypes =
                completeAccount?.currency === CURRENCY_CODE.USD ? checksTypesListUSD : checksTypesList;
            if (!filteredCheckTypes?.some((check) => check.value === checkType)) {
                checkType = "";
            }
            setValues({ ...template, checksTypes: checkType });
        } else {
            this.getCheckBookChecksAmount(checkType);
            setValues(template);
        }

        setErrors({});
    };

    rightContentMobile = () => (
        <ButtonDrawer
            buttonClassName=""
            width="100%"
            bsStyle="link"
            image="images/template-icon.svg"
            styleImage={{ width: "24px", height: "24px", color: "white" }}
            styleCloseButton={{ color: "white" }}
            backButton
            closeButton={false}
            headerContent={
                <div className="title-account-header-multiline-background-blue">
                    <h1 className="m-0">{i18n.get("transfers.templates.label")}</h1>
                </div>
            }
            content={<TemplateList onSelect={this.handleTemplateSelect} className="navigational-list" />}
            contentClassname="mx-3"
        />
    );

    render() {
        const {
            values,
            accounts,
            isDesktop,
            setValues,
            fetching,
            checksTypesList,
            location,
            templates,
            checksRequestData,
            documentType,
            isSmallDesktop,
            loggedUser,
            dispatch,
            checksTypesListUSD,
            defaultAccount,
        } = this.props;
        const { account, checksTypes } = values;
        const { alreadyFetch, alreadyFetchRest, buttonDisabled } = this.state;
        const accountsFiltered = accounts?.filter((a) => a.permiteChequera === "SI");

        const selectedAccount = accountsFiltered.find((a) => a.idProduct === defaultAccount) ?? null;

        if (location.pathname === "/checks" && !alreadyFetchRest) {
            this.setState({ alreadyFetchRest: true });
            dispatch(checkActions.fetchAccounts(loggedUser.userId));
            dispatch(templateActions.loadTemplateList("requestCheckbook"));
        }

        if (account === "" && accountsFiltered && accountsFiltered.length > 0) {
            setValues({
                ...values,
                account:
                    location.pathname !== "/checks"
                        ? checksRequestData?.account.idProduct
                        : selectedAccount?.idProduct ?? accountsFiltered[0].idProduct,
            });
        }

        if (values.documentType === "") {
            const valueDocumentType = location.pathname !== "/checks" ? checksRequestData?.documentType : "DNI";

            setValues({
                ...values,
                documentType: documentType || valueDocumentType,
            });
        }
        if (location.pathname !== "/checks" && !alreadyFetch) {
            this.getCheckBookChecksAmount(
                checksRequestData?.checksTypes?.value || checksRequestData?.checksTypes,
                checksRequestData?.checkBookChecksAmount,
            );
            this.setState({ alreadyFetch: true });
        }

        let filteredCheckTypes = checksTypesList;
        if (this.echeqUSDfuncionalites) {
            const completeAccount = accounts?.find(({ idProduct }) => idProduct === (account.value || account));
            filteredCheckTypes = completeAccount?.currency === CURRENCY_CODE.USD ? checksTypesListUSD : checksTypesList;
        }

        const { embeddedInV3Shell } = this.props;

        return (
            <>
                {!embeddedInV3Shell && (
                    <>
                        <Notification scopeToShow="requestChecks" />
                        <Notification scopeToShow="form" />
                    </>
                )}
                <CreateTemplateModal values={values} idForm="requestCheckbook" idActivityTemplate="account.checks" />
                {!isDesktop && !embeddedInV3Shell && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            headerClassName="blue-main-header-mobile"
                            centerElement={this.centerContentMobile}
                            centerContentClassName="mx-5"
                            rightContent={templates.length > 0 && this.rightContentMobile}
                            accessibilityTextId={
                                checksRequestData?.returnToPending ? "modify.check.request" : "new.check.request"
                            }
                        />
                    </div>
                )}
                {isDesktop && (
                    <div className="admin-detail-head px-0">
                        <Head
                            onBack={this.handleBack}
                            accessibilityTextId={
                                checksRequestData?.returnToPending ? "modify.check.request" : "new.check.request"
                            }
                        />
                        <div className="view-title">
                            <h1>
                                {i18n.get(
                                    checksRequestData?.returnToPending ? "modify.check.request" : "new.check.request",
                                )}
                            </h1>
                        </div>
                    </div>
                )}
                <PageLoading loading={fetching} className="screen-loader">
                    <div>
                        {accountsFiltered && (
                            <Form>
                                <Container
                                    className={classNames(
                                        "container--layout flex-grow align-items-center cmf-container-white py-3 mt-4",
                                        { "mb-4": isDesktop },
                                    )}
                                    gridClassName="form-content">
                                    <Col sm={12} lg={isSmallDesktop ? 12 : 8} className="align-items-center">
                                        <Col sm={12} className="col-no-pad-mobile">
                                            <Field
                                                name="account"
                                                component={Productselector}
                                                idField="account"
                                                customPlaceholder="Seleccioná"
                                                data={{
                                                    emptyOptionLabel: "",
                                                    options: accountsFiltered,
                                                }}
                                                value={account}
                                                isRequired
                                                mode="edit"
                                                labelText="new.check.account"
                                                idForm={FORM_ID}
                                                isDesktop={isDesktop}
                                            />
                                        </Col>
                                        <Col sm={12} className="col-no-pad-mobile">
                                            <Field
                                                idForm={FORM_ID}
                                                name="checksTypes"
                                                component={Selector}
                                                customOnChange
                                                onCustomChange={(checkType) => this.getCheckBookChecksAmount(checkType)}
                                                options={filteredCheckTypes}
                                            />
                                        </Col>
                                        <Col sm={12} md={6} className="col-no-pad-mobile">
                                            <Field
                                                idForm={FORM_ID}
                                                name="checkBookChecksAmount"
                                                hidePlaceholder
                                                component={Selector}
                                                options={this.checksAmountOptions(filteredCheckTypes)}
                                            />
                                        </Col>
                                        <Col sm={12} md={6} className="col-no-pad-mobile">
                                            <Field
                                                idForm={FORM_ID}
                                                name="checkBooksAmount"
                                                hidePlaceholder
                                                component={Selector}
                                                options={this.createCheckBooksAmount()}
                                            />
                                        </Col>
                                        {filteredCheckTypes?.find((type) => type.value === checksTypes)
                                            ?.showsDeliveryPoint && (
                                            <>
                                                {this.renderInputs(values, setValues)}
                                                <Col sm={12} className="col-no-pad-mobile">
                                                    <Heading.DataGroup
                                                        containerClassName="transfer-data data-wrapper-flex"
                                                        label={`${FORM_ID}.delivery.point`}
                                                    />
                                                </Col>
                                                <Col sm={12} className="col-no-pad-mobile">
                                                    <div>
                                                        <I18n id={`${FORM_ID}.delivery.point.description`} />
                                                    </div>
                                                </Col>
                                                <Col sm={12} className="col-no-pad-mobile">
                                                    <Hint
                                                        idMessage={`${FORM_ID}.hint`}
                                                        styleText={{ maxWidth: "100%" }}
                                                        styleImage={{
                                                            alignSelf: "center",
                                                            marginTop: "0.7rem",
                                                        }}
                                                        classNameHintP="hint-font-size-small"
                                                        alwaysShowMessage
                                                    />
                                                </Col>
                                            </>
                                        )}
                                        {!filteredCheckTypes?.find((type) => type.value === checksTypes)
                                            ?.showsDeliveryPoint && (
                                            <Col sm={12} className="col-no-pad-mobile">
                                                <Hint
                                                    idMessage={`${FORM_ID}.hint.echeq`}
                                                    styleText={{ maxWidth: "100%" }}
                                                    styleImage={{ alignSelf: "center", marginTop: "0.7rem" }}
                                                    classNameHintP="hint-font-size-small"
                                                    alwaysShowMessage
                                                />
                                            </Col>
                                        )}
                                    </Col>
                                </Container>

                                {isDesktop && templates.length > 0 && (
                                    <Container
                                        className="container--layout flex-grow align-items-center"
                                        gridClassName="form-content">
                                        <Col sm={12} md={3} lg={3} xl={3} className="align-items-center">
                                            <h2>{i18n.get("transfers.templates.label")}</h2>
                                            <TemplateList
                                                onSelect={this.handleTemplateSelect}
                                                className="navigational-list"
                                            />
                                        </Col>
                                    </Container>
                                )}

                                <Container>
                                    <Col sm={12} lg={isSmallDesktop ? 12 : 8} className="align-items-center">
                                        <Col sm={12} className="col-no-pad-mobile">
                                            <div
                                                className={classNames("mb-4 d-flex gap-3", {
                                                    "justify-content-center pl-3 pr-3": isDesktop,
                                                    "f-dir-col-reverse pt-45": !isDesktop,
                                                })}>
                                                <Button
                                                    bsStyle="outline"
                                                    onClick={this.saveDraft}
                                                    label="transfers.actions.saveDraft"
                                                    className={classNames("m-0")}
                                                    disabled={buttonDisabled}
                                                />
                                                <Button
                                                    bsStyle="outline"
                                                    onClick={this.handleCreateTemplateClick}
                                                    label="transfers.actions.saveTemplate"
                                                    className={classNames("m-0")}
                                                />
                                                <Button
                                                    type="submit"
                                                    bsStyle="primary"
                                                    label="global.continue"
                                                    className={classNames("m-0")}
                                                />
                                            </div>
                                        </Col>
                                    </Col>
                                </Container>
                            </Form>
                        )}
                    </div>
                </PageLoading>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    loggedUser: sessionSelectors.getUser(state),
    accounts: checkSelector.getAccounts(state),
    fetching: checkSelector.getFetchAccounts(state),
    checksTypesList: checkSelector.getChecksTypes(state),
    checksTypesListUSD: checkSelector.getChecksTypesUSD(state),
    checksAmount: checkSelector.getChecksAmount(state),
    checksRequestData: checkSelector.getChecksRequestData(state),
    templates: templateSelectors.getTemplateList(state),
    defaultAccount: checkSelector.getDefaultAccount(state),
    lastPathname: statusSelectors.getPathname(state),
});

const documentTypeFormats = (documentType, document) => {
    const isnum = /^\d+$/.test(document);
    if (documentType === "DNI") {
        if (document.length < 6 || document.length > 8 || !isnum) {
            return false;
        }
    }

    if (documentType === "CUIT" || documentType === "CUIL" || documentType === "CDI") {
        if (document.length !== 11 || !isnum) {
            return false;
        }
    }
    return true;
};

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: (props) => ({
            account:
                props.location.pathname !== "/checks"
                    ? props.checksRequestData?.account.idProduct || props.checksRequestData?.account
                    : "",
            checksTypes:
                props.location.pathname !== "/checks"
                    ? props.checksRequestData?.checksTypes?.value || props.checksRequestData?.checksTypes
                    : "",
            checkBookChecksAmount:
                props.location.pathname !== "/checks" ? props.checksRequestData?.checkBookChecksAmount : "",
            checkBooksAmount: props.location.pathname !== "/checks" ? props.checksRequestData?.checkBooksAmount : 1,
            documentType: "",
            document: props.location.pathname !== "/checks" ? props.checksRequestData?.document : "",
            name: props.location.pathname !== "/checks" ? props.checksRequestData?.name : "",
            surname: props.location.pathname !== "/checks" ? props.checksRequestData?.surname : "",
        }),
        validationSchema: (props) => {
            const { checksTypesList } = props;
            let validateObject = {
                account: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                checksTypes: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                checkBooksAmount: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                checkBookChecksAmount: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
            };
            return Yup.lazy((values) => {
                if (checksTypesList?.find((type) => type.value === values.checksTypes)?.showsDeliveryPoint) {
                    validateObject = {
                        account: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                        checksTypes: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                        checkBooksAmount: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                        name: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                        surname: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                        document: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                        checkBookChecksAmount: Yup.string().required(i18n.get(`${FORM_ID}.field.error.required`)),
                    };
                }
                return Yup.object().shape(validateObject);
            });
        },

        handleSubmit: (
            { account, checksTypes, checkBookChecksAmount, checkBooksAmount, documentType, document, name, surname },
            formikBag,
        ) => {
            const {
                dispatch,
                accounts,
                checksTypesList,
                checksTypesListUSD,
                checksRequestData,
                location,
            } = formikBag.props;
            const formatValidation = documentTypeFormats(documentType, document, formikBag);
            const completeAccount = accounts.find(({ idProduct }) => idProduct === (account.value || account));

            let filteredCheckTypes = checksTypesList;
            const echeqUSDfuncionalites = configUtils.getBoolean("frontend.ECHEQsUSD.functionalities", false);
            if (echeqUSDfuncionalites) {
                filteredCheckTypes =
                    completeAccount?.currency === CURRENCY_CODE.USD ? checksTypesListUSD : checksTypesList;
            }
            if (
                formatValidation ||
                !filteredCheckTypes?.find((type) => type.value === checksTypes)?.showsDeliveryPoint
            ) {
                const completeCheckType = filteredCheckTypes?.find(({ value }) => value === checksTypes);
                dispatch(
                    checkActions.checksRequestData({
                        account: completeAccount,
                        checksTypes: echeqUSDfuncionalites
                            ? { ...completeCheckType, checksAmount: null }
                            : completeCheckType,
                        checkBookChecksAmount,
                        checkBooksAmount,
                        documentType,
                        document,
                        name,
                        surname,
                        returnToPending: checksRequestData?.returnToPending,
                        checksTransactionListGoBackPath: checksRequestData?.checksTransactionListGoBackPath,
                        idTransaction: checksRequestData?.idTransaction,
                    }),
                );
                if (checksRequestData?.returnToPending) {
                    saveDraft();
                }
                const returnPath = location?.state?.return;
                dispatch(
                    push({
                        pathname: "/checks/summary",
                        ...(returnPath ? { state: { return: returnPath } } : {}),
                    }),
                );
            } else {
                formikBag.setErrors({ document: i18n.get("login.step1.wrong.format") });
                formikBag.setSubmitting(false);
            }
        },
    }),
    resizableRoute,
)(Checks);
